export const TIME_OUT = 300000; // 5 minutes

export const HTTP_RESPONSE = {
    COMMON: {
        UNAUTHORIZED: {
            code: 401,
        },
        FORBIDDEN: {
            code: 403,
        },
    },
};
